import { render, staticRenderFns } from "./TabPlusIcon.vue?vue&type=template&id=3003e0ec"
import script from "./TabPlusIcon.vue?vue&type=script&lang=js"
export * from "./TabPlusIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports